'use strict';

module.exports = ['$interval', 'moment',
    function($interval, moment) {

        return {
            restrict: 'A',
            scope: {
                rmActiveItem: '@',
                item: '='
            },
            link: function(scope, element, attributes) {
                let start = moment(scope.item.start),
                    stop = moment(start),
                    broadcast = element.parent().parent();
                stop.add(scope.item.duration, 'seconds');
                function checkActive() {
                    if(broadcast.attr('rm-active-broadcast') == 'active') {
                        let now = moment();

                        if(now.diff(stop) > 0) {
                            if(scope.rmActiveItem == 'active') {
                                element.css('opacity', 0.75);
                                scope.rmActiveItem = 'inactive';
                            }
                        } else if(scope.rmActiveItem == 'inactive') {
                            element.css('opacity', 1);
                            scope.rmActiveItem = 'active';
                        }

                        if(now.diff(stop) < 0 && now.diff(start) > 0) {
                            let nowEl = angular.element('.dashboard-container').find('#now');
                            if(nowEl.length > 0) {
                                $(element).before(nowEl);
                            }
                        } else if(now.diff(start) > 0 && now.diff(stop) > 0) {
                            let nowEl = angular.element('.dashboard-container').find('#now');
                            if(nowEl.next().is(element)) {
                                $(broadcast).before(nowEl);
                            }
                        }
                    }
                }

                $interval(checkActive, 5000); //set an interval and check the active state

                checkActive();
            }
        };
    }
];

